import * as RecombeeJSAPIClient from 'recombee-js-api-client';

import { getSystemIdByDomain } from '@utils/system';
import { renderListArticleFromTwig, GTMHighlight } from '@components';

import { CNCRecombee } from '@customTypes/recombee/CNCRecombee';
import { recombeeAddDomStructure as addDomStructure } from './recombeeAddDomStructure';

/*
  Vytvořit elementy a překreslit DOM v 'listArticle' boxu
  Elementy jsou vytváření na základě DOM struktury v '/data/templates/src/twig/default/components/def-article-card.twig',
  viz '/data/templates/src/twig/default/components/def-article-card-recombee-pattern.twig'
*/

interface RecombeeCreateElementsAndRenderDOMProps {
  list: HTMLElement | null;
  listIndex: number;
  replace?: boolean;
  resp: RecombeeJSAPIClient.RecombeeClientResponse;
}

export const recombeeCreateElementsAndRenderDOM = ({
  list,
  listIndex,
  replace = false,
  resp,
}: RecombeeCreateElementsAndRenderDOMProps) => {
  // Načíst a připravit konfiguraci z boxu v CMS ('Vlastny konfig')
  if (!window.CNC.recombee || !window.CNC.recombee.box) return;

  const {
    list: listName = 'articleList',
    scenario,
    hideAuthor,
    variant,
    hideDate,
    hideMagazineName,
    hideTime,
  } = window.CNC.recombee.box[listIndex];

  // Pro všechny doporučené články
  resp.recomms.forEach((article: CNCRecombee.Article, recommmIndex: number) => {
    const recombeeQueryKey = 'recombee_recomm_id=';

    // Připravit hodnoty GTM
    const {
      author,
      categories,
      domain,
      image,
      is_premium: isPremium,
      locked,
      main_category_name: mainCategoryName,
      main_category_urlize: mainCategoryUrl,
      magazine_name: magazineName,
      published_at: publishedAt,
      title,
      url: link,
      image_small: imageSmall,
      image_medium: imageMedium,
      image_large: imageLarge,
    } = article.values;

    const recombeeSrcSet: CNCRecombee.SRCset = {
      small: imageSmall || null,
      medium: imageMedium || null,
      large: imageLarge || null,
    };

    // Připravit render DOMu
    const loadedArticle = renderListArticleFromTwig({
      hideAuthor,
      variant,
      hideDate,
      hideMagazineName,
      hideTime,
      id: article.id,
      author,
      categoryNames: categories,
      position: recommmIndex + 1,
      publishedAt: new Date(publishedAt * 1000),
      imageUrl: image,
      isPremium: locked || isPremium,
      listName,
      mainCategoryName,
      mainCategoryUrl,
      magazineName,
      crossScenario: scenario.includes('-odjinud'),
      title,
      source: scenario.includes('-odjinud')
        ? `crossSiteRecommended-${scenario}`
        : `siteRecommended-${scenario}`,
      systemId: getSystemIdByDomain(domain.replace('www.', '')),
      url: `${link}${link.includes('?') ? '&' : '?'}${recombeeQueryKey}${resp.recommId}`,
      recombeeSrcSet,
    });

    // Přidat do DOMu
    addDomStructure({
      list,
      newDom: loadedArticle,
      recommmIndex,
      replace,
    });
  });

  if (window.gtmService && window.gtmService.observe instanceof Function) {
    window.gtmService.observe();
  }

  // Zvýraznit GTM elementy
  GTMHighlight();
};
